import React, { useState, useRef, useEffect } from 'react';
import { ArrowLeft, ArrowRight } from 'react-feather'
import SidebarNav from './SidebarNav'
import { useSelector } from 'react-redux'
import { RootState } from '../../ReduxToolkit/Store'
import ConfigDB from '../../Config/ThemeConfig'
import { useDispatch } from 'react-redux';
import { setSideBarToggle } from '../../ReduxToolkit/Reducers/Layout/LayoutReducer'

export default function Sidebar() {
    const { sideBarToggle } = useSelector((state: RootState) => state.layout);
    const dispatch = useDispatch();
    const wrapper = ConfigDB.settings.sidebar.type;
    const [margin, setMargin] = useState(0);
    const [leftArrow, setLeftArrow] = useState(true);
    const sidebarIconType = useSelector((state: RootState) => state.themeCustomizer.sideBarIconType);
    const sideBarIcon = sidebarIconType || ConfigDB.settings.sidebar.iconType;

    const sidebarRef = useRef(null);

    // Close sidebar when clicking outside (only on small screens)
    // useEffect(() => {
    //     const handleClickOutside = (event: MouseEvent) => {
    //         if (
    //             sidebarRef.current &&
    //             !(sidebarRef.current as HTMLElement).contains(event.target as Node) &&
    //             window.innerWidth <= 1042 &&
    //             sideBarToggle === false
    //         ) {
    //             dispatch(setSideBarToggle(true)); // close sidebar
    //         }
    //     };

    //     document.addEventListener('mousedown', handleClickOutside);
    //     return () => document.removeEventListener('mousedown', handleClickOutside);
    // }, [sideBarToggle]);

useEffect(() => {
  const handleClickOutside = (event: MouseEvent) => {
    const sidebarEl = sidebarRef.current as HTMLElement | null;
    const toggleBtn = document.querySelector('.toggle-sidebar') as HTMLElement | null;

    if (
      window.innerWidth <= 1042 &&
      sideBarToggle === false && // sidebar is open
      sidebarEl &&
      !sidebarEl.contains(event.target as Node) &&
      !(toggleBtn && toggleBtn.contains(event.target as Node))
    ) {
      dispatch(setSideBarToggle(true)); // close the sidebar
    }
  };

  document.addEventListener('mousedown', handleClickOutside);
  return () => document.removeEventListener('mousedown', handleClickOutside);
}, [sideBarToggle]);

    const scrollToRight = () => {
        if (margin > -3000) {
            setMargin((prevMargin) => prevMargin - 500);
            setLeftArrow(false);
        }
    };

    const scrollToLeft = () => {
        setMargin((prevMargin) => prevMargin + 500);
        if (margin === -600) {
            setMargin(0);
            setLeftArrow(true);
        }
    };

    return (
        <aside
            ref={sidebarRef}
            className={`page-sidebar ${sideBarToggle ? 'close_icon' : ''} ${sideBarIcon === 'iconcolor-sidebar' ? 'iconcolor-sidebar' : ''}`}
            data-sidebar-layout={sideBarIcon}
        >
            <div className={`left-arrow ${leftArrow ? "disabled" : ""}`} id="left-arrow" onClick={scrollToLeft}><ArrowLeft /></div>
            <div className="main-sidebar" id="main-sidebar" style={{ marginLeft: margin + "px" }}>
                <SidebarNav onItemClick={() => {
                    if (window.innerWidth <= 1042) dispatch(setSideBarToggle(true)); // close on submenu click
                }} />
            </div>
            {wrapper === "horizontal-sidebar" && <div className='right-arrow' onClick={scrollToRight} id="right-arrow"><ArrowRight /></div>}
        </aside>
    );
}












//3/6/25
// import React, { useState } from 'react'
// import { ArrowLeft, ArrowRight } from 'react-feather'
// import SidebarNav from './SidebarNav'
// import { useSelector } from 'react-redux'
// import { RootState } from '../../ReduxToolkit/Store'
// import ConfigDB from '../../Config/ThemeConfig'

// export default function Sidebar() {
//     const { sideBarToggle } = useSelector((state: RootState) => state.layout)
//     const wrapper = ConfigDB.settings.sidebar.type;
//     const [margin, setMargin] = useState(0);
//     const [leftArrow, setLeftArrow] = useState(true);
//     const sidebarIconType = useSelector((state: RootState) => state.themeCustomizer.sideBarIconType);
//     const sideBarIcon = sidebarIconType || ConfigDB.settings.sidebar.iconType;

//     const scrollToRight = () => {
//         if (margin > -3000) {
//             setMargin((prevMargin) => prevMargin - 500);
//             setLeftArrow(false);
//         }
//     };
//     const scrollToLeft = () => {
//         setMargin((prevMargin) => prevMargin + 500);
//         if (margin === -600) {
//             setMargin(0);
//             setLeftArrow(true);
//         }
//     };
//     return (
//         <>
//             <aside className={`page-sidebar ${sideBarToggle ? 'close_icon' : ''} ${sideBarIcon === 'iconcolor-sidebar' ? 'iconcolor-sidebar' : ''}`} data-sidebar-layout={sideBarIcon}>
//                 <div className={`left-arrow ${leftArrow ? "disabled" : ""}`} id="left-arrow" onClick={scrollToLeft}><ArrowLeft /></div>
//                 <div className="main-sidebar" id="main-sidebar" style={{ marginLeft: margin + "px" }}>
//                     <SidebarNav />
//                 </div>
//                 {(wrapper === "horizontal-sidebar") && (<div className='right-arrow' onClick={scrollToRight} id="right-arrow"><ArrowRight /></div>)}
//             </aside>
//         </>
//     )
// }